import React from "react";

const AISummaryModalSkeleton = ({ width = "500px" }) => {
  const lines = Array.from({ length: 3 }, (_, i) => i);

  const getWidth = (index) => {
    if (index % 3 === 0) return "83%";
    if (index % 2 === 0) return "66%";
    return "100%";
  };

  return (
    <div
      style={{
        borderRadius: "8px",
        backgroundColor: "#ffffff",
        width: width,
        maxWidth: "100%",
        minHeight: "60px",
      }}
    >
      {lines.map((line, index) => (
        <div
          key={index}
          style={{
            height: "12px",
            backgroundColor: "#e0e0e0",
            borderRadius: "6px",
            marginBottom: "8px",
            width: getWidth(index),
            animation: "pulse 1.5s infinite",
          }}
        />
      ))}

      <style>
        {`
          @keyframes pulse {
            0%, 100% {
              opacity: 1;
            }
            50% {
              opacity: 0.4;
            }
          }

          div[style*="animation: pulse"] {
            animation-timing-function: ease-in-out;
          }
        `}
      </style>
    </div>
  );
};

export default AISummaryModalSkeleton;
